import { render } from "./UsuarioPage.vue?vue&type=template&id=1c2af1f4"
import script from "./UsuarioPage.vue?vue&type=script&lang=js"
export * from "./UsuarioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__